import {
  Autocomplete,
  Box,
  Button,
  Paper,
  Snackbar,
  Stack,
  TextField,
  Typography,
  IconButton,
} from '@mui/material'
import Save from '@mui/icons-material/Save'
import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UploadFile } from '~/src/components/molecules'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import CancelIcon from '@mui/icons-material/Cancel'
import DeleteIcon from '@mui/icons-material/Delete'
import { SxProps } from '@mui/system'
import { Theme } from '@mui/material/styles'

interface IOrderStatementOfAccountContent {
  label: string
  alignItems?: 'center' | 'start' | 'baseline'
  sx?: SxProps<Theme>
  children?: React.ReactNode
}

export const OrderStatementOfAccountContent: FC<IOrderStatementOfAccountContent> = ({
  label,
  alignItems = 'center',
  sx,
  children,
}) => {
  return (
    <Box sx={{ flexDirection: 'row', display: 'flex', alignItems }} paddingBottom={'20px'}>
      <Typography
        sx={{
          color: 'text.primary',
          fontSize: 16,
          fontWeight: 'regular',
          width: 163,
          ...sx,
        }}
        marginRight={'16px'}
      >
        {label}
      </Typography>
      {children}
    </Box>
  )
}
